import { AbstractCommand } from 'src/models/command';

class AddAnIdoFavoriteCommand extends AbstractCommand {
	readonly name = 'IFS_Organization_IdoLinkDropZone_Command_Command_AddAnIdoFavorite';

	public constructor(idoId: number, idoInstanceId: number) {
		super();
		this.parameters = {
			idoId: idoId,
			idoInstanceId: idoInstanceId,
		};
	}
}

export { AddAnIdoFavoriteCommand };
